module.exports = __webpack_public_path__ + "img/运动之星选中.00f2159d.png";